import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useIconProps } from '../useIconProps';

var Close = function Close(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M8.839 7.987l2.579-2.554.526-.525c.075-.075.075-.2 0-.3l-.551-.552c-.1-.075-.226-.075-.3 0l-3.08 3.105-3.105-3.105c-.075-.075-.2-.075-.3 0l-.552.551c-.075.1-.075.226 0 .3l3.105 3.08-3.105 3.105c-.075.075-.075.2 0 .3l.551.552c.1.075.226.075.3 0l3.106-3.105 2.553 2.579.526.526c.075.075.2.075.3 0l.552-.551c.075-.1.075-.226 0-.3L8.839 7.986z"
  }));
};

Close.displayName = 'Close';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Close.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Close;